export const FORM_KEYS = {
	providerDisplayName: 'providerDisplayName',
	redirectURL: 'redirectURL',
	expirationTime: 'expirationTime',
	expirationTimeUnit: 'expirationTimeUnit',
	textServiceProvider: 'textServiceProvider',
	textMessageBody: 'textMessageBody',
	emailServiceProvider: 'emailServiceProvider',
	emailSubject: 'emailSubject',
	emailBody: 'emailBody',
	customEmailSubject: 'customEmailSubject',
	customEmailBody: 'customEmailBody',
	customTextMessageBody: 'customTextMessageBody',
	resetAuthMethod: 'resetAuthMethod'
};
